  
import Home from "./pages/home";


import FullStackDeveloperForManagers from './pages/Full-Stack-Developer-For-Managers';
import FullStackDeveloperForUndergraduate from "./pages/Full-Stack-Developer-For-Undergraduate";
import MEANStackFullStackDevelopersCourse from "./pages/MEAN-Stack-Full-Stack-Developers-Course";
import MERNStackForBeginners from './pages/MERN-Stack-For-Beginners';


import logo from "./logo.svg";
import React, { Component, useEffect } from "react"; 
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";

function App() {

  // const location = useLocation();

  // useEffect(() => {
  //   if (location.pathname !== '/' && location.pathname.endsWith('/')) {
  //     const newPath = `/data-science-course-one${location.pathname.slice(0, -1)}`;
  //     window.location.replace(newPath);
  //     console.log(newPath);
  //   }
  //   console.log(location);
  // }, [location]);

  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route path='/Full-Stack-Developer-For-Managers' element={<FullStackDeveloperForManagers/>}/>
      <Route path='/Full-Stack-Developer-For-Undergraduate' element={<FullStackDeveloperForUndergraduate/>}/>
      <Route path='/MEAN-Stack-Full-Stack-Developers-Course' element={<MEANStackFullStackDevelopersCourse/>}/>
      <Route path='/MERN-Stack-For-Beginners' element={<MERNStackForBeginners/>}/>
     
    </Routes>
  );
}

export default App;
